import * as Ruleset from '../../methods/set.js';
import { Keyword, Number, ValidatedArray } from '../../values/index.js';
export var Platform;
(function (Platform) {
    Platform["google"] = "google";
    Platform["adobe"] = "adobe";
    Platform["custom"] = "custom";
})(Platform || (Platform = {}));
export var VariantStyle;
(function (VariantStyle) {
    VariantStyle["normal"] = "normal";
    VariantStyle["italic"] = "italic";
})(VariantStyle || (VariantStyle = {}));
const normalizeFontVariant = (variant = {}) => {
    var _a;
    return ({
        name: String(variant.name),
        familyName: String(variant.familyName),
        weight: (_a = Number(variant.weight)) !== null && _a !== void 0 ? _a : 400,
        style: Keyword(variant.style, VariantStyle)
    });
};
export const FontVariant = (variant) => normalizeFontVariant(variant);
export const VariantReference = (props) => {
    return props;
};
VariantReference.Fix = (fontVariantReference, styles) => {
    var _a, _b;
    if (fontVariantReference == null)
        return null;
    if (!('id' in fontVariantReference) || !('name' in fontVariantReference))
        return fontVariantReference;
    // If it doesn't exist return a color reference with color id the internal color's id.
    const fonts = Ruleset.filterByType(styles, 'font');
    const font = fonts.find((style) => style.details.id === fontVariantReference.id);
    const variant = fonts.find((style) => { var _a, _b; return (_b = (_a = style.props) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b.find((v) => v.name === fontVariantReference.name); });
    if (!font) {
        return null;
    }
    if (!variant) {
        return ((_b = (_a = font.props) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b.length) ? { ...fontVariantReference, name: font.props.variants[0].name } : null;
    }
    return fontVariantReference;
};
export const Props = (props = {}) => ({
    familyName: props.familyName || null,
    platform: Keyword(props.platform, Platform),
    variants: ValidatedArray(FontVariant, props.variants)
});
export const fix = (props, styles) => {
    //if (!props.familyName) return null
    return props;
};
export const validate = () => true;
export const type = 'font';
export const category = 'basic';
export const label = 'Font';
export const forms = [
    {
        id: 'font',
        label: 'Font selector',
        extractProperties: (props) => props,
        validate: () => true
    }
];
//# sourceMappingURL=font.js.map